import { createContext, FunctionComponent, PropsWithChildren, useContext } from 'react';
import { FormSchema } from './types';

export const formRendererContext = createContext<FormSchema | null>(null);

export const FormRendererContextProvider: FunctionComponent<
  PropsWithChildren<{ schema: FormSchema }>
> = ({ children, schema }) => (
  <formRendererContext.Provider value={schema}>{children}</formRendererContext.Provider>
);

export const useFormRendererData = () => useContext(formRendererContext);
